import React, { useCallback, useEffect, useState } from "react";
import MoreOptions from "../../../../../../client/CommonComponents/MoreOptions";
import { useDispatch, useSelector } from "react-redux";
import { getUserGridData } from "../../../../../../redux/UserManagement/action";
import selectors from "../../../../../../redux/UserManagement/selectors";
import UserManagementGrid from "./UserManagementGrid";
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors'
import { fetchGridPayload } from "utils";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";

type IProps = {
  setSelectedKey: (evt: string) => void;
  setSelectedUser?: any;
};

const UserManagementGridContainer = ({
  setSelectedKey,
  setSelectedUser,
}: IProps) => {

  const [data, setData] = React.useState([]);
  const [searchFilter, setSearchFilter] = React.useState<any>('user');
  const [searchedText, setSearchedText] = React.useState<any>('');
  const [paginationData, setPaginationData] = useState<any>({})
  const [sortData, setSortData] = useState<any>({})
  const [pagesCount, setPagesCount] = useState<number>(0)
  const [serverTotal, setServerTotal] = useState(0)
  const [filters, setFilters] = useState<any>({})
  const [showGrid, setShowGrid] = useState(false)

  const dispatch = useDispatch();

  const { userGridData, userDetails }: any = useSelector((state) => ({
    userGridData: selectors.getUserGridData(state),
    userDetails: userProfileSelectors.getUserDetails(state),
  }));

  useEffect(() => {
    setSelectedUser('');
  }, []);

  useEffect(() => {
    setData(userGridData.data);
    setServerTotal(userGridData?.totalRecords)
    let pageSize = paginationData?.pageSize
    let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
    setPagesCount(tempPageCount)
    setShowGrid(true)
  }, [userGridData, paginationData, serverTotal]);

  const option = [
    {
      title: "Edit User Security Role",
      value: "editUser",
    },
  ];

  const columns = [
    {
      key: "action",
      title: "Action",
      Cell: (row: any) => {
        return (
          <>
            <MoreOptions
              onClick={optionHandler}
              options={option}
              {...row.rowData}
             data-attribute="UserManagementGrid_container_Default_MoreOptions" />
          </>
        );
      },
      width: 50,
    },
    {
      key: "firstName",
      title: "First Name",
      width: 200,
      filterRowValue: filters['firstName'] || ''
    },
    {
      key: "lastName",
      title: "Last Name",
      width: 200,
      filterRowValue: filters['lastName'] || ''
    },
    {
      key: "userId",
      title: "User ID",
      width: 200,
      filterRowValue: filters['userId'] || ''
    },
    {
      key: "employeeId",
      title: "Employee ID",
      width: 200,
      filterRowValue: filters['employeeId'] || ''
    },
  ];

  const searchClickHandler = () => {
    if (searchedText) {
      setPaginationData((prev: any) => ({...prev, pageIndex: 0}))
      setShowGrid(false)
      fetchGridData(searchedText)
    } else {
      fetchGridData()
    }
  }

  const clearFilter = () => {
    setPaginationData((prev: any) => ({...prev, pageIndex: 0}))
    fetchGridData()
    setShowGrid(false)
  }

  const searchFilterChange = (event: any, option: any) => {
    setSearchFilter(option.key);
  }

  const searchTextChange = (event: any, value: string) => {
    setSearchedText(value);
  }
  const onExportExcel = () => { };

  const optionHandler = (evt: any, option: any, selectedOption: any) => {
    if (option.value === "editUser") {
      setSelectedUser(selectedOption.userId);
      setSelectedKey("add-edit-user");
    }
  };

  const debounceObject = [ paginationData, sortData, filters ]
  const debouncedSearchedText = useDebounce(searchedText, 500)

  const globalDebounce = useDebounce(debounceObject, 500)

  const fetchGridData = (globalSearchText = '') => {
    let payload: any = {
      "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
      "pageSize": paginationData?.pageSize,
      "columnFilters": Object
      .keys(filters)
      ?.reduce((acc :any ,filter: any) => {
        if(filters[filter]){
          acc.push({
            'field': filter,
            'value': filters[filter]
          })
        }
        return acc
      }, []),
      "loggedInMail": userDetails?.emailId
    }

    payload = fetchGridPayload(payload, [], globalSearchText, sortData, true, searchFilter)

    if (userDetails?.emailId && payload.pageNumber && payload.pageSize) {
      dispatch(getUserGridData(payload))
    }
  }

  useEffect(() => {
    fetchGridData(debouncedSearchedText)
  }, [globalDebounce, debouncedSearchedText])

  const setFiltersValue = (filters: any) => {
    if (JSON.stringify(filters) !== '{}') {
      setFilters(filters);
      }
  }

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPaginationData(paginationData)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortData(data);
    }
  }, [])

  return (
    <UserManagementGrid
      data={data}
      columns={columns}
      onExportExcel={onExportExcel}
      searchFilterChange={searchFilterChange}
      searchFilter={searchFilter}
      searchTextChange={searchTextChange}
      searchedText={searchedText}
      searchClickHandler={searchClickHandler}
      clearFilter={clearFilter}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
      setFiltersValue={setFiltersValue}
      fetchAction={fetchAction}
      showGrid={showGrid}
    />
  );
};

export default UserManagementGridContainer;
